import Resource from '../../../api/resources/Resource'
import { SAMPLE_STATES } from '@/api/resources/entityState/sample-state'
import { keyBy, merge } from 'lodash'

class LaboratorySectionService extends Resource {
    constructor() {
        super()
        this.fullSampleStates = []
    }
    async getSampleStates() {
        const response = await this.axios.get(`/laboratory/samples/laboratoryStates`)
        this.fullSampleStates = Object.values(merge(keyBy(response.data, 'code'), keyBy(SAMPLE_STATES, 'code')))
        return this.fullSampleStates
    }
    getFullSampleStates() {
        return this.fullSampleStates
    }
    async getSampleById(labId, casId, samId) {
        return this.axios.get(`/laboratory/laboratories/${labId}/cases/${casId}/samples/${samId}`).then(response => response.data)
    }
    async updateSample(labId, casId, samId, data) {
        return this.axios.put(`/laboratory/laboratories/${labId}/cases/${casId}/samples/${samId}`, data).then(response => response.data)
    }
}

export const STATUS_OPTIONS_LABORATORY_SAMPLE = [
    SAMPLE_STATES.REGISTERED.code,
    SAMPLE_STATES.PREPROCESSED.code,
    SAMPLE_STATES.IN_PROCESSOR.code,
    SAMPLE_STATES.PROCESSED.code,
    SAMPLE_STATES.REPROCESSING_REQUESTED.code,
    SAMPLE_STATES.OUT_OF_LABORATORY.code
]

export default new LaboratorySectionService()
